import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { Fragment, ReactNode, useMemo } from "react";
import { RevTooltip } from "@revmatics/catalyst";

type Props = {
  title: string;
  tooltip?: string;
  selectedList?: string[];
  children: ReactNode;
};

export const DisclosureFilter = ({
  title,
  tooltip,
  selectedList,
  children,
}: Props) => {
  const selectedText = useMemo(() => {
    if (selectedList && selectedList.length > 0) {
      return `${selectedList.slice(0, 4).join(", ")} ${
        selectedList.length > 4
          ? `+ ${selectedList.length - 4} more selected`
          : "selected"
      }`;
    } else {
      return "";
    }
  }, [selectedList]);

  return (
    <Disclosure defaultOpen={true}>
      {({ open }) => (
        <div>
          <DisclosureButton as={Fragment}>
            <button className="w-full flex gap-2 justify-between py-2.5 px-6 bg-transparent items-center border-t border-monochrome-200 outline-0">
              <div className="flex flex-wrap flex-col md:flex-row gap-1 items-start md:items-center">
                <div className="flex items-center gap-1">
                  <h6 className="whitespace-nowrap">{title}</h6>
                  {tooltip && (
                    <RevTooltip content={tooltip} position="top">
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="text-monochrome-600 hover:text-primary-500 transition-colors"
                      />
                    </RevTooltip>
                  )}
                </div>
                {selectedText && (
                  <p
                    data-testid="selected-disclosure-text"
                    className="typography-body-sm text-monochrome-900 text-start"
                  >
                    {selectedText}
                  </p>
                )}
              </div>
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`text-monochrome-600 ${open ? "rotate-180" : ""}`}
              />
            </button>
          </DisclosureButton>
          <DisclosurePanel as={Fragment}>
            <div className="w-full bg-transparent pb-4 px-6">{children}</div>
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  );
};
